import { createAction } from 'redux-actions'

export const setStepIndex = createAction('TOUR/SET_STEP_INDEX', stepIndex => stepIndex)
